const API = process.env.REACT_APP_API_BASE || 'https://sequentus-content.azurewebsites.net/api';

export async function getScenario(excludeIds: string[] = []) {
  const params = excludeIds.length ? `?exclude=${excludeIds.join(',')}` : '';
  const res = await fetch(`${API}/survey/scenario${params}`);
  return res.json();
}

export async function getFactors() {
  const res = await fetch(`${API}/survey/factors`);
  return res.json();
}

export async function submitResponseV2(data: any) {
  const res = await fetch(`${API}/survey/respond/v2`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return res.json();
}

export async function subscribe(email: string, sessionToken: string) {
  const res = await fetch(`${API}/survey/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, sessionToken }),
  });
  return res.json();
}

export async function getStats() {
  const res = await fetch(`${API}/survey/stats`);
  return res.json();
}
